<script setup>
import { onMounted, onUnmounted, ref } from "vue"
import { useRegisterSW } from "virtual:pwa-register/vue"

const online = ref(navigator.onLine)
let registration

useRegisterSW({
  immediate: true,
  onRegisteredSW(_url, value) {
    registration = value
  },
  onRegisterError(error) {
    console.error("Vendor Portal service worker registration failed:", error)
  },
})

function checkForUpdate() {
  if (navigator.onLine && document.visibilityState === "visible") {
    registration?.update().catch((error) => {
      console.warn("Unable to check for a portal update:", error)
    })
  }
}

function updateConnection() {
  online.value = navigator.onLine
  if (online.value) checkForUpdate()
}

onMounted(() => {
  window.addEventListener("online", updateConnection)
  window.addEventListener("offline", updateConnection)
  document.addEventListener("visibilitychange", checkForUpdate)
})

onUnmounted(() => {
  window.removeEventListener("online", updateConnection)
  window.removeEventListener("offline", updateConnection)
  document.removeEventListener("visibilitychange", checkForUpdate)
})
</script>

<template>
  <aside v-if="!online" class="pwa-status" aria-label="App status" aria-live="polite">
    <p v-if="!online">
      You’re offline. Reconnect to load portal data and save changes.
    </p>
  </aside>
</template>

<style scoped>
.pwa-status {
  position: fixed;
  bottom: calc(5rem + env(safe-area-inset-bottom));
  right: 1rem;
  left: 1rem;
  z-index: 60;
  max-width: 24rem;
  margin-left: auto;
  padding: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.75rem;
  background: #fff;
  color: #0f2535;
  box-shadow: 0 4px 16px #0002;
  font-size: 0.875rem;
}
</style>
